module.exports = require('@wix/communities-forum-universal/dist/src/constants/appsConfig.prod');
